<template>
    <div 
        :style="Object.assign( { zIndex: zIndex }, background ? { backgroundImage: 'url(' + background + ')'} : {} )" 
        :class="['van-hairline--top-bottom',classes({ fixed: fixed, 'safe-area-inset-bottom': safeAreaInsetBottom })]"
      >
        <slot></slot>
      </div>
</template>

<script>
import { classesMixin } from "../../../common/mixins/classname";
import { ParentMixin } from "../../../common/mixins/relation";
let classMixin = classesMixin("tabbar");
export default {
    name: 'h-tabbar',
    mixins: [classMixin, ParentMixin("hanzoTabbar")],
    props: {
        value: Number,
        activeColor: String,
        inactiveColor: String,
        safeAreaInsetBottom: Boolean,
        fixed: {
            type: Boolean,
            default: true
        },
        zIndex: {
            type: Number,
            default: 1
        },
        background: String
    },

    watch: {
        children() {
            this.setActiveItem();
        },

        value() {
            this.setActiveItem();
        }
    },

    methods: {
        setActiveItem() {
            this.children.forEach((item, index) => {
                item.active = index === this.value;
            });
        },

        onChange(active) {
            if (active !== this.value) {
                this.$emit('input', active);
                this.$emit('change', active);
            }
        }
    }
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>